import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Trash2 } from "lucide-react";

export default function Sales() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([
    {
      productId: "",
      quantity: 1,
      price: 0,
      mrp: 0,
      total: 0,
      stock: 0,
      batchno: "",
      manufacturingdate: "",
      expirydate: ""
    }
  ]);

  const [customer, setCustomer] = useState("");
  const [paymentType, setPaymentType] = useState("Cash");
  const [customerlists, setCustomerlists] = useState([]);
  const [productlists, setProductlists] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [dueDate, setDueDate] = useState("");

  const [invoiceno, setInvoiceno] = useState("");
  const [batchno, setBatchno] = useState("");
  const [loading, setLoading] = useState(false);

  const [creditDays, setCreditDays] = useState("");

  //Get Customers lists
  useEffect(() => {
    getCustomers();
    getInvoice();
    getCurrentdate();
  }, [selectedCustomer]);

  const getInvoice = async () => {
    try {
      const response = await axios.get(
        "http://tntyping.com/Adminconsole/api/getnextinvoiceno"
      );

      if (response.data) {
        setInvoiceno(response.data);
      }
    } catch (error) {
      //console.log("Invoice Error:", error);
    }
  };

  // console.log("Invoice no: ", invoiceno);

  const getCustomers = async () => {
    try {
      await axios
        .get("http://tntyping.com/Adminconsole/api/nutscustomerlist")
        .then(function (response) {
          // console.log("The Response is: ", response);
          if (response.data.errorCode === 2) {
            Swal.fire({
              icon: "error",
              text: response.data.Message,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });
          }

          if (response.data.errorCode === 0) {
            setCustomerlists(response.data.result);
            getProducts();
          }
        });
    } catch (error) {
      // console.log("Error is: ", error);
    }
  };

  //Fetch Products based on customer id
  const getProducts = async () => {
    try {
      //console.log("Customer ID:", selectedCustomer.id);

      await axios
        .get(
          "http://tntyping.com/Adminconsole/api/nutscustomerproductpricelistbyid?customerid=" +
            selectedCustomer.id
        )
        .then(function (response) {
          // console.log("I am here", response);
          if (response.data.errorCode === 2) {
            Swal.fire({
              icon: "error",
              text: response.data.Message,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });
          }

          if (response.data.errorCode === 0) {
            setProductlists(response.data.result);
          }
        });
    } catch (error) {
      //  console.log("Error:", error);
    }
  };

  //Get Current Date
  const getCurrentdate = () => {
    return new Date().toISOString().split("T")[0];
  };

  //Calculate the due date
  const calculateDueDate = (days) => {
    const today = new Date();
    today.setDate(today.getDate() + Number(days));

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleChange = (index, field, value) => {
    const updated = [...rows];

    updated[index][field] = value;

    // When product changes
    if (field === "productId") {
      const selected = productlists.find(
        (p) => String(p.productid) === String(value)
      );

      if (selected) {
        updated[index].price = Number(selected.price);
        updated[index].mrp = Number(selected.price);
        updated[index].batchno = selected.batchno;
        updated[index].manufacturingdate = selected.manufacturingdate;
        updated[index].expirydate = selected.expirydate;
        updated[index].stock = Number(selected.stock);
        updated[index].quantity = 1;
      }
    }

    if (field === "quantity") {
      const enteredQty = Number(value);
      const availableStock = updated[index].stock;

      if (enteredQty > availableStock) {
        Swal.fire({
          icon: "warning",
          text: `Only ${availableStock} stock available`,
          width: 320
        });
        return;
      }

      updated[index].quantity = enteredQty;
    }

    updated[index].total =
      Number(updated[index].quantity) * Number(updated[index].price);

    setRows(updated);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        productId: "",
        quantity: 1,
        price: 0,
        mrp: 0,
        total: 0,
        stock: 0,
        batchno: "",
        manufacturingdate: "",
        expirydate: ""
      }
    ]);
  };

  const subtotal = rows.reduce((sum, row) => sum + row.total, 0);
  const gst = subtotal * 0.0;
  const grandTotal = subtotal + gst;

  const handleRemoveRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);

    if (updated.length === 0) {
      updated.push({ productId: "", quantity: 1, price: 0, total: 0 });
    }

    setRows(updated);
  };

  const saveInvoice = async () => {
    if (!selectedCustomer) {
      Swal.fire({
        icon: "error",
        text: "Please select customer",
        width: 320,
        padding: "1em"
      });
      return;
    }

    if (rows.length === 0) {
      Swal.fire({
        icon: "error",
        text: "Please add product",
        width: 320,
        padding: "1em"
      });
      return;
    }

    const confirm = await Swal.fire({
      text: "Do you want to create this invoice?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
      width: 320,
      padding: "1em",
      customClass: {
        popup: "rounded-xl text-sm"
      }
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);

    try {
      const payload = {
        invoiceno: invoiceno,
        customerid: selectedCustomer.id,
        customername: selectedCustomer.customername,
        paymenttype: paymentType,
        duedate: dueDate,
        items: rows.map((row) => {
          const product = productlists.find(
            (p) => String(p.productid) === String(row.productId)
          );

          return {
            productId: row.productId,
            productname: product ? product.productname : "",
            quantity: row.quantity,
            price: row.price,
            total: row.total,
            batchno: row.batchno,
            manufacturingdate: row.manufacturingdate,
            expirydate: row.expirydate
          };
        })
      };

      const response = await axios.post(
        "http://tntyping.com/Adminconsole/api/nutscreateinvoice",
        payload
      );

      if (response.data.errorCode === 2) {
        Swal.fire({
          icon: "error",
          text: response.data.Message,
          width: 320,
          timer: 1500,
          showConfirmButton: false,
          padding: "1em",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });
      }

      if (response.data.errorCode === 0) {
        Swal.fire({
          icon: "success",
          text: response.data.Message,
          width: 320,
          timer: 1500,
          showConfirmButton: false,
          padding: "1em",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });

        // Reset form
        setCustomer("");
        setSelectedCustomer(null);

        setRows([
          {
            productId: "",
            quantity: 1,
            price: 0,
            mrp: 0,
            total: 0,
            batchno: "",
            manufacturingdate: "",
            expirydate: ""
          }
        ]);

        setPaymentType("Cash");
        setDueDate(getCurrentdate());
      }
    } catch (error) {
      //console.log("Error:", error);

      Swal.fire({
        icon: "error",
        text: "Something went wrong"
      });
    }

    setLoading(false);
  };

  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // Go View Invoice
  const goViewinvoice = () => {
    navigate("/invoices");
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Page Title */}
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-800">
          Create Sales Invoice
        </h2>

        <button
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg shadow"
          onClick={goViewinvoice}
        >
          View Invoices
        </button>
      </div>

      {/* Invoice Header */}
      {/* Invoice Header */}
      <div className="bg-white p-4 rounded-xl shadow grid grid-cols-4 gap-4 items-end">
        {/* Customer */}
        <div>
          <label className="text-xs text-gray-500">Customer</label>
          <select
            value={customer}
            onChange={(e) => {
              const selectedId = e.target.value;
              setCustomer(selectedId);

              const cust = customerlists.find(
                (c) => String(c.id) === String(selectedId)
              );

              setSelectedCustomer(cust);
            }}
            className="border border-gray-300 rounded-lg w-full px-2 py-1.5 mt-1 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Customer</option>

            {customerlists.map((cust) => (
              <option key={cust.id} value={cust.id}>
                {cust.customername} ({cust.type})
              </option>
            ))}
          </select>
        </div>

        {/* Payment Type */}
        <div>
          <label className="text-xs text-gray-500">Payment Type</label>
          <select
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
            className="border border-gray-300 rounded-lg w-full px-2 py-1.5 mt-1 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option>Cash</option>
            <option>UPI</option>
            <option>Bank Transfer</option>
          </select>
        </div>

        {/* Credit Days */}
        <div>
          <label className="text-xs text-gray-500">Credit Days</label>
          <select
            value={creditDays}
            onChange={(e) => {
              const days = e.target.value;
              setCreditDays(days);

              if (days) {
                const newDueDate = calculateDueDate(days);
                setDueDate(newDueDate);
              }
            }}
            className="border border-gray-300 rounded-lg w-full px-2 py-1.5 mt-1 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Days</option>
            <option value="30">30 Days</option>
            <option value="45">45 Days</option>
            <option value="60">60 Days</option>
            <option value="90">90 Days</option>
          </select>
        </div>

        {/* Due Date */}
        <div>
          <label className="text-xs text-gray-500">Due Date</label>
          <input
            type="date"
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
            className="border border-gray-300 rounded-lg w-full px-2 py-1.5 mt-1 text-sm focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Products Table */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="p-4 text-left">Product</th>
              <th className="p-4 text-center">Stock</th>
              <th className="p-4 text-center">Quantity</th>
              <th className="p-4 text-center">Customer Price</th>
              <th className="p-4 text-center">Total</th>
              <th className="p-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => (
              <tr key={index} className="border-t hover:bg-gray-50">
                <td className="p-3">
                  <select
                    value={row.productId}
                    onChange={(e) =>
                      handleChange(index, "productId", e.target.value)
                    }
                    className="border rounded-lg px-3 py-2 w-full"
                  >
                    <option value="">Select Product</option>

                    {productlists.map((p) => (
                      <option
                        key={p.productid}
                        value={p.productid}
                        disabled={p.stock <= 0}
                      >
                        {p.productname} - (Batch: {p.batchno}) - (From:{" "}
                        {formatDate(p.manufacturingdate)}) - (To:{" "}
                        {formatDate(p.expirydate)}) - (Stock: {p.stock})
                      </option>
                    ))}
                  </select>
                </td>

                <td className="p-3 text-center text-gray-500">{row.stock}</td>

                <td className="p-3 text-center">
                  <input
                    type="number"
                    value={row.quantity}
                    min="1"
                    onChange={(e) =>
                      handleChange(index, "quantity", e.target.value)
                    }
                    className="border rounded-lg w-20 px-2 py-1 text-center"
                  />
                </td>

                <td className="p-3 text-center text-gray-700">₹{row.price}</td>

                <td className="p-3 text-center font-semibold text-gray-900">
                  ₹{row.total}
                </td>

                <td className="p-3 text-center">
                  <button
                    onClick={() => handleRemoveRow(index)}
                    className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1 rounded"
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Add Item */}
        <div className="p-4 border-t">
          <button
            onClick={handleAddRow}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            + Add another item
          </button>
        </div>
      </div>

      {/* Totals */}
      <div className="flex justify-end">
        <div className="bg-white p-6 rounded-xl shadow w-80 space-y-3">
          <div className="flex justify-between text-gray-600">
            <span>Subtotal</span>
            <span>₹{subtotal.toFixed(2)}</span>
          </div>

          {/* 
          <div className="flex justify-between text-gray-600">
            <span>GST (5%)</span>
            <span>₹{gst.toFixed(2)}</span>
          </div>
          */}

          <div className="border-t pt-3 flex justify-between font-bold text-lg">
            <span>Total</span>
            <span>₹{grandTotal.toFixed(2)}</span>
          </div>

          <button
            onClick={saveInvoice}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg shadow flex items-center gap-2"
          >
            {loading && (
              <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-4 h-4"></span>
            )}
            {loading ? "Creating..." : "Create Invoice"}
          </button>
        </div>
      </div>
    </div>
  );
}
